<template>
  <div class="picker-goods">
    <div class="form-search">
      <el-input class="form-name" v-model="formData.item_name" @blur="refresh()" placeholder="请输入商品名称"></el-input>
      <el-button type="primary" @click="onAdd">添加商品</el-button>
      <el-button type="primary" @click="onBatchDelete">批量删除</el-button>
    </div>

    <SpFinder ref="finder" reserve-selection :row-key="rowKey" :url="url()" fixed-row-action :setting="setting"
      row-actions-width="150" :other-config="{ 'max-height': '730' }" :hooks="{
        beforeSearch: beforeSearch,
        afterSearch: afterSearch
      }" @select-all="handleSelectAll" @select="handleSelectAll">
    </SpFinder>
  </div>
</template>

<script>
import { createSetting } from '@shopex/finder'
import { getGiftordergoodsList, getGiftordergoods, deleteGiftordergoods, giftingordergoodsStatus } from '@/api/giving'

export default {
  data() {
    return {
      formData: {
        item_name: ''
      },
      rowKey: 'goods_id',
      checkedList: [],
    }
  },
  computed: {
    setting() {
      return createSetting({
        columns: [
          { name: '商品ID', key: this.rowKey, width: 100 },
          {
            name: '商品名称',
            key: 'item_name',
          },
          {
            name: '启用状态', key: 'status',
            render: (h, { row }) => {
              return <el-switch
                v-model={row.status}
                active-value='1'
                inactive-value='0'
                on-change={(value) => this.onStatusChange(row, value)}
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            }
          },
        ],
        actions: [
          {
            name: '删除',
            key: 'show',
            type: 'button',
            buttonType: 'text',
            action: {
              handler: async (row) => {
                this.onDeleteGiftordergoods(row[0].goods_id)
              }
            }
          },
        ]
      })
    }
  },
  mounted() {

  },
  methods: {
    url() {
      return getGiftordergoodsList()
    },
    async onAdd() {
      const { data } = await this.$picker.goodsitem({
        data: this.relItems,
        paramsFieldExclude: ['distributor_id'],
        queryParams: {
          is_sku: false,
          is_edu: 0,
          is_subsidy: 2
        },
        rowKey: 'goods_id',
        multiple: true
      })

      // 循环data,获取goods_id的集合
      const goods_ids = data.map(item => item.goods_id)
      this.addGetGiftordergoods(goods_ids.join(','))
    },
    handleSelectAll(list) {
      this.checkedList = list
    },
    onBatchDelete() {
      if (this.checkedList.length === 0) {
        this.$message.error('请选择要删除的商品')
        return
      }
      const goods_ids = this.checkedList.map(item => item.goods_id)
      this.onDeleteGiftordergoods(goods_ids.join(','))
    },
    onDeleteGiftordergoods(v) {
      let params = {
        goods_ids: v
      }
      deleteGiftordergoods(params).then(res => {
        const { success } = res.data.data
        if (success) {
          this.$message.success('删除成功')
          this.$refs.finder.refresh(true)
        }
      })
    },
    beforeSearch(params) {
      params = {
        ...params,
        page_size: params.pageSize,
        ...this.formData,
        is_edu: 0
      }
      delete params.pageSize
      return params
    },
    afterSearch() {

    },
    addGetGiftordergoods(v) {
      let params = {
        goods_ids: v
      }
      getGiftordergoods(params).then(res => {
        this.$refs.finder.refresh(true)
      })
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    onStatusChange(row, value) {
      let params = {
        goods_id: row.goods_id,
        status: value
      }
      giftingordergoodsStatus(params).then(res => {
        this.$message.success('修改成功')
      })
    }
  }
}
</script>
<style scoped type="text/css" lang="scss">
.form-search {
  margin-bottom: 10px;
}

.form-name {
  width: 200px !important;
}
</style>
